import { useTranslation } from 'react-i18next';

import { ChangelogFeed } from '@r/components/changelogs/changelog-feed.tsx';

/**
 * Page « Nouveautés » accessible depuis le menu Mon Compte : flux chronologique
 * des évolutions de l’espace, avec recherche, filtres et scroll infini.
 */
export function ChangelogsFeed() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-10 grow">
      <div className="space-y-3">
        <h1 className="text-4xl font-bold">{t('changelog.feed.title')}</h1>
        <p className="font-light text-muted-foreground">{t('changelog.feed.subtitle')}</p>
      </div>

      <ChangelogFeed />
    </div>
  );
}
